import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'reporting/sector',
        pathMatch: 'full'
    },
    {
        path: ':group/:item',
        loadComponent: () => import('./components/dashboard/dashboard.component').then(c => c.DashboardComponent),
    }
];
